export default __webpack_public_path__ + "static/media/websitedevelopment01.f4628428.jpeg";